module.exports = __webpack_public_path__ + "ring-twilight-neon.c4d6a966a378a522a027.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/ring-twilight-neon.svg
// module id = ../../../../../src/assets/img/ring-twilight-neon.svg
// module chunks = main